module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.ttf?698bd8550d863c20a3e163bbd65141e8";